export const transformFloatToEnglishLocale = number =>
  typeof number === 'string'
    ? Number.parseFloat(number.replace(',', '.'))
    : number
